import React, { useState } from 'react';
import './NewsPage.css';
import AegleDivider from '../components/AegleDivider';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Divider, useMediaQuery } from '@mui/material';
import { newsItems } from './NewsItems';

const handleCardClick = (link: string) => {
  window.open(link, '_blank', 'noopener,noreferrer');
};

export const NewsPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div>
      {/* Header Section */}
      <section className="NewsPage-section">
        <h1>Aegle News</h1>
        <AegleDivider color="#368caa" />
        <p className="tagline">The industry through our lens - relevant news and insights all in one place.</p>
      </section>

      {/* News Grid Section */}
      <section className="news-grid">
        {newsItems.map((item, index) => (
          <div
            key={index}
            className="news-card"
            onClick={() => handleCardClick(item.link)}
            role="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                handleCardClick(item.link);
              }
            }}
          >
            <div className="card-image">
              <img src={item.image} alt={item.alt} />
            </div>
            <div className="card-content">
              <h3>{item.title}</h3>
              <p className="source">{item.source}</p>
            </div>
          </div>
        ))}

      </section>

    </div>
  );
}
export default NewsPage;